import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getDistributor = async (searchText) => {
  try {
    const url = `${apiUrl}/members/distributor/search${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getMerchants = async (searchText) => {
  try {
    const url = `${apiUrl}/members/merchants/search-by-distributor${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const getAllMembers = async (searchText) => {
  try {
    const url = `${apiUrl}/members/search-all-member${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

export { getDistributor, getMerchants, getAllMembers };
